import { CobroDetalle } from "./cobro_detalle";
import { CobroGrupo } from "./cobro-grupo"
import { AsientoContable } from "./asiento-contable";

export class Cobro{
    public constructor(
        public id: String = "",
        public fecha_cobro: any = "",
        public saldo: number = 0,
        public recibido: number = 0,
        public cambio: number = 0,
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public tipo_doc: String = "",
        public tipo_documento_id: String = "",
        public observacion: string = "",
        //public caja_id: String = "",

        public usuario_id:String = null,
        public detalle: Array<CobroDetalle> = [],
        public grupo: Array<CobroGrupo> = [],

        public asientosContables: Array<AsientoContable> = [],
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cobro.ts